export default __webpack_public_path__ + "static/media/vetinthemoun.3b91f411.png";